function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M20.509 18.156c.47.47.706 1.033.706 1.686 0 .654-.235 1.216-.706 1.687a2.452 2.452 0 01-1.686.627c-.654 0-1.216-.21-1.686-.627l-5.176-5.96-5.176 5.96a2.452 2.452 0 01-1.686.627c-.654 0-1.216-.21-1.686-.627a2.452 2.452 0 01-.628-1.687c0-.653.21-1.215.628-1.686l5.41-6.117-5.41-6.195a2.452 2.452 0 01-.628-1.686c0-.654.21-1.216.628-1.687a2.452 2.452 0 011.686-.627c.653 0 1.215.21 1.686.627l5.176 5.96 5.176-5.96a2.452 2.452 0 011.686-.627c.653 0 1.215.21 1.686.627.47.47.706 1.033.706 1.687 0 .653-.235 1.215-.706 1.686l-5.411 6.195 5.411 6.117"
});

function SvgCancel(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _ref);
}

export default SvgCancel;